import { render } from "./FormComponent.vue?vue&type=template&id=d5bf1dc8"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__